import { useMemo } from "react";
import { useMutation, useQueryClient } from "react-query";
import { makeAuthedRequest } from "shared/utils/makeAuthedRequest";

export function useBSMs({ contact }) {
  const queryClient = useQueryClient();
  const returnable = useMemo(
    () => contact.handouts.filter((h) => !h.isConsumable),
    [contact.handouts]
  );

  const returnBSMMutation = useMutation(
    (handoutId) =>
      makeAuthedRequest(`/prospects/handout/${contact.id}/${handoutId}/false`, {
        method: "delete",
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(`/contacts/${contact.id}`);
      },
    }
  );

  return {
    returnable,

    returnBSMMutation,
  };
}
